import PropTypes from 'prop-types';
import { useTranslation } from '@eti/providers';
import { Notification, variants } from '@eti/components';
import { css } from '@eti/styles';
import { Text } from '@etg/wings';
import { isOutBound, isInBound, isMultiStop } from '../../../utils/notification';
import BoundTitle from './BoundTitle';
import Segment from './Segment';

const getKey = (index: number) => `key-${index}`;

const segmentsStyles = (isFirstBound: boolean) => css`
  margin-top: ${isFirstBound ? '1rem' : '2rem'};
`;

interface ScheduleNotificationProps {
  className?: string;
  closeButtonDataTestId?: string;
  content: any[]; // TODO: Add proper type when getScheduleNotificationContent becomes typed.
  dataTestId?: string;
  onClose?: () => void;
}

const ScheduleNotification = ({
  className,
  closeButtonDataTestId,
  content = [],
  dataTestId,
  onClose,
  ...rest
}: ScheduleNotificationProps) => {
  const { t } = useTranslation();

  return (
    <Notification
      className={className}
      closeButtonDataTestId={closeButtonDataTestId}
      closeButtonLabel={t('Close')}
      dataTestId={dataTestId}
      onClose={onClose}
      variant={variants.INFORMATION}
      {...rest}
    >
      <>
        <Text as="p" variant="16-bold">
          {t('Notification.TripScheduleChange.Header.Text')}
        </Text>
        {content.map((bound, boundIndex) => (
          <div className={segmentsStyles(boundIndex === 0)} key={getKey(boundIndex)}>
            {isOutBound(content, bound, boundIndex) && (
              <BoundTitle text={t('TripDetails.OutBoundTitle')} />
            )}
            {isInBound(content, bound, boundIndex) && (
              <BoundTitle shouldRotateIcon text={t('TripDetails.InBoundTitle')} />
            )}
            {isMultiStop(content, bound) && (
              <BoundTitle
                text={`${t('Notification.TripScheduleChange.Trip.Text')} ${boundIndex + 1}`}
              />
            )}
            {bound.segments.map(
              (
                segment: any /* TODO: Add proper type when getScheduleNotificationContent becomes typed */,
                segmentIndex: number,
              ) => (
                <Segment
                  content={segment}
                  isLastSegmentInBound={segmentIndex === bound.segments.length - 1}
                  key={getKey(segmentIndex)}
                />
              ),
            )}
          </div>
        ))}
      </>
    </Notification>
  );
};

ScheduleNotification.propTypes = {
  className: PropTypes.string,
  closeButtonDataTestId: PropTypes.string,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.any)]),
  dataTestId: PropTypes.string,
  onClose: PropTypes.func,
};

export default ScheduleNotification;
